import { render, staticRenderFns } from "./SetupPassword.vue?vue&type=template&id=52105f0e&scoped=true"
import script from "./SetupPassword.vue?vue&type=script&lang=js"
export * from "./SetupPassword.vue?vue&type=script&lang=js"
import style0 from "./SetupPassword.vue?vue&type=style&index=0&id=52105f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52105f0e",
  null
  
)

export default component.exports